import { manufacturingFetch } from "@/lib/manufacturingClient";

export type MaterialUsagePlantOption = { id: string; name: string };

export type MaterialUsageRecipient = {
  id: string;
  plant_id: string;
  user_id: string | null;
  email: string | null;
  display_name: string | null;
  kind: "user" | "address";
};

export type MaterialUsageMemberOption = {
  user_id: string;
  email: string | null;
  display_name: string;
};

export type MaterialUsageRecipientContext = {
  ok: true;
  organization_id: string;
  plants: MaterialUsagePlantOption[];
  recipients: MaterialUsageRecipient[];
  members: MaterialUsageMemberOption[];
  approved_domains: string[];
};

export function listMaterialUsageRecipients() {
  return manufacturingFetch<MaterialUsageRecipientContext>("/api/service/material-usage/recipients", {
    method: "GET",
  });
}

export function addMaterialUsageRecipient(payload: { plant_id: string; user_id?: string; email?: string }) {
  return manufacturingFetch<{ ok: true; id: string }>("/api/service/material-usage/recipients/add", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function removeMaterialUsageRecipient(id: string) {
  return manufacturingFetch<{ ok: true }>("/api/service/material-usage/recipients/remove", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  });
}
